import { useQuery, useQueryClient } from 'react-query'
import { fetchOrder, awaitInspection } from '../../services'
import { fetchWarehouse } from '../../services/warehouseSevices'
import { GenerateReplenishmentLabel } from '../Replenishments/GenerateReplenishmentLabel'
import { Route, Switch, useHistory, useLocation, useParams } from 'react-router-dom'
import {
  Button,
  ConfirmDialog,
  Loader,
  PageTopBar,
  PageView,
  SearchInput,
  SlidePanel,
  TextareaField,
  InputField,
  DialogView,
  Notification,
} from '../../components'
import { useEffect, useMemo, useState } from 'react'
import { AutoComplete, Input, InputNumber, Select, Skeleton } from 'antd'
import { DamagedIcon } from '../../components/Icons/DamagedIcon'
import { TrashIcon } from '../../components/Icons/TrashIcon'
import { createReturn, receiveReturn } from '../../services/returnServices'
import { SelectReturnedProductDialog } from '../Orders/CreateReturn/SelectReturnedProductDialog'
import { fetchReturn, fetchReturnID } from '../../services/returnServices'
import { getStatusDefinition, RETURNS_STATUSES, ORDER_STATUSES } from '../../components/BasicTable/StatusPillDefinitions'
import { getReturnTypeDefinition } from './ReturnTypes'
import { resolveReturnReceiveErrorMessage } from './errorMessages'
import {
  RETURNS,
  RECEIVE_RETURN,
  SHOW_RECEIVING_ORDER,
  ORDERS_SHIPPED,
  SHOW_CREATING_RETURN_ORDER,
  CREATE_RETURN,
  SEARCH_RETURN,
} from '../../navigation/constants'
import { isUnidentifiedReturnsEnabled } from './returnPolicy'
import { isAllMissingReceipt, shouldResetSubmitData, summarizeMissingProducts } from './returnReceiveRules'
import { ShowOrderContainer } from '../Orders/ShowOrderContainer'
import { useRef } from 'react'
import { fetchProductsBySkyOrUpc, fetchProductLots } from '../../services/productServices'
import { XIcon } from '@heroicons/react/solid'
import { SearchIcon } from '@heroicons/react/outline'
import { CreateLotsDialog } from '../Replenishments/CreateLotsDialog'
import { TableImage } from '../../components/TableImage'
import { useTranslation } from 'react-i18next'
import { cloneDeep, escape } from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import { ReturnCameraRecorder } from './ReturnCameraRecorder'
import { generateRandomId } from '../../helpers/WebcamHelper'
import {
  setRecordingState,
  setLastStatus,
  stopRecording as stopReturnRecording,
  isRecording as selectReturnIsRecording,
  fileIdentifier as selectReturnFileIdentifier,
  lastStatus as selectReturnLastStatus,
  startedAt as selectReturnStartedAt,
} from '../../redux/returnVideoRecorderSlice'


export const ReceiveReturnContainer = ({ onSuccess = () => {}, onCancel = () => {} }) => {
  const { id, warehouse_id, orderId } = useParams()
  const history = useHistory()
  // What the operator actually scanned, forwarded by the returns list. Not always the
  // order number (a shipping-label number resolves to the order too), and the
  // unidentified-return receipt is keyed by the scanned value.
  const scannedString = useLocation().state?.scannedString
  const [params, setParams] = useState({ warehouse_id: warehouse_id })

  // Return-receiving video proof. The recorder + preview live in ReturnCameraRecorder,
  // mounted below only when the platform asks for this receipt to be filmed (so the camera/permission
  // prompt never fires for warehouses that don't use it). Recording is best-effort.
  const dispatch = useDispatch()
  const returnCameraIsRecording = useSelector(selectReturnIsRecording)
  const returnCameraFileIdentifier = useSelector(selectReturnFileIdentifier)
  const returnCameraLastStatus = useSelector(selectReturnLastStatus)
  const returnCameraStartedAt = useSelector(selectReturnStartedAt)
  const returnRecordingStartedForIdRef = useRef(null)
  const queryClient = useQueryClient()
  const { i18n, t } = useTranslation()

  const [openDialogLabel, setOpenDialogLabel] = useState(false)
  const [replenishmentInfo, setReplenishmentInfo] = useState(null)
  const [invalidReturn, setInvalidReturn] = useState(false)
  const [modifiedSubmitData, setModifiedSubmitData] = useState(false)
  const [showConfirmDialog, setShowConfirmDialog] = useState(false)
  // The all-missing dialog opens once the generic confirm dialog has fully left (two Headless UI
  // dialogs must not hold the focus trap at once), so the hand-off goes through this flag.
  const [allMissingPending, setAllMissingPending] = useState(false)
  const [allMissingProducts, setAllMissingProducts] = useState(null)
  const [receiveOnlyCompleteReturns, setReceiveOnlyCompleteReturns] = useState(false)
  const [sealedConfirmed, setSealedConfirmed] = useState(false)
  const [showInspectionModal, setShowInspectionModal] = useState(false)
  //const [showSelectReturnedProductDialog, setShowSelectReturnedProductDialog] =
  //  useState(false)
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const [ignoreNextModifiedSubmitData, setIgnoreNextModifiedSubmitData] = useState(true)
  const [submitData, setSubmitData] = useState({
    return_id: null, // Only used if "id" param exists (receiving return)
    order_id: null, // Only used if "orderId" param exists (creating return)
    notes: '', // Only used if "orderId" param exists (creating return)
    return_tracking_number: null,
    products: [],
    warehouse_id: warehouse_id,
  })

  const [textToSearch, setTextToSearch] = useState('')
  const [messageProductsNotFound, setProductsNotFound] = useState(false)
  const [messageProductsNotFoundInOrder, setProductsNotFoundInOrder] = useState(false)
  const searchInputRef = useRef(null)
  const [productSearchIsLoading, setproductSearchIsLoading] = useState(false)
  const [showCreateLotsDialog, setShowCreateLotsDialog] = useState(false)
  const [productToCreateLot, setProductToCreateLot] = useState({})
  const [exists, setExists] = useState(false)
  const [lastScannedProduct, setLastScannedProduct] = useState({ id: 0 })
  const [activeLot, setActiveLot] = useState(null)
  const [foundProducts, setFoundProducts] = useState([])
  const [notificationMessage, setNotificationMessage] = useState({ show: false, type: 'error', title: '' })

  /* const {
    isLoading: isLoadingReturnID, 
    isFetching: isFetchingReturnID,
    isError: isErrorReturnID,
    error: errorReturnID,
    data: returnID,
  } = useQuery(["return_order",orderId ], () => fetchReturnID(orderId) ,{
    enabled: orderId !== undefined,
    onSuccess: fetchedData => {
      id = fetchedData.id
    }
  }) */

  const {
    isLoading,
    isFetching,
    isError,
    error,
    data: returnData,
    refetch,
  } = useQuery(['return', id], () => fetchReturn(id), {
    enabled: id !== undefined,
    onSuccess: fetchedData => {
      setSubmitData({ ...submitData, return_id: fetchedData.id })
    },
  })

  const [dialog, setDialog] = useState({
    loading: false,
    open: false,
    title: '',
    description: '',
    type: null,
  })

  const {
    isLoading: orderIsLoading,
    isFetching: orderIsFetching,
    isError: orderIsError,
    error: orderError,
    data: orderData,
  } = useQuery(['order', orderId], () => fetchOrder(orderId), {
    enabled: orderId !== undefined,
    onSuccess: fetchedData => {
      setSubmitData({ ...submitData, order_id: fetchedData.id })
    },
  })

  const {
    isLoading: isLoadingWarehouse,
    isError: isErrorWarehouse,
    error: errorWarehouse,
    data: warehouse,
    isPreviousData: isPreviousDataWarehouse,
  } = useQuery('warehouse', () => fetchWarehouse(warehouse_id), { keepPreviousData: true })

  // Start recording when a receipt opens, once per screen visit, and stop when the platform no
  // longer asks for it (camera_recording_required: the warehouse films returns and the return can
  // still be received, the visit after an inspection included). Only fires for the
  // receive-existing-return flow (id param).
  const cameraRecordingRequired = returnData?.camera_recording_required === true
  useEffect(() => {
    if (id === undefined || !returnData) return
    const receivable = cameraRecordingRequired
    if (receivable && returnRecordingStartedForIdRef.current !== id) {
      returnRecordingStartedForIdRef.current = id
      dispatch(setLastStatus(null))
      dispatch(setRecordingState({ isRecording: true, fileIdentifier: `return_${id}_${generateRandomId()}` }))
    } else if (!receivable && returnRecordingStartedForIdRef.current === id) {
      dispatch(stopReturnRecording())
    }
  }, [cameraRecordingRequired, id, returnData, dispatch])

  // Sent with the receipt (and with the move to inspection) so the platform keeps the recording of
  // this visit. Only a visit that asked to record sends one, since the redux identifier can be a
  // previous screen's; whether the camera actually started is the platform's to read from the
  // camera events.
  const buildReturnCameraStatus = () => {
    if (returnRecordingStartedForIdRef.current !== id) return null
    return {
      recording: !!returnCameraIsRecording,
      file_identifier: returnCameraFileIdentifier || null,
      status: returnCameraLastStatus || null,
      started_at: returnCameraStartedAt || null,
    }
  }

  useEffect(() => {
    let returnedOrder = null
    let isInvalid = true
    let shouldReset = false
    let dataExists = false

    if (id !== undefined) {
      returnedOrder = returnData?.returned_order
      isInvalid = returnData?.status !== 'REQUESTED' && returnData?.status !== 'ARRIVED_AT_WAREHOUSE' && returnData?.status !== 'AWAITING_INSPECTION'
      shouldReset = shouldResetSubmitData({ currentId: id, heldId: submitData?.return_id, modified: modifiedSubmitData })
      dataExists = !!returnData
    } else if (orderId !== undefined) {
      const has_multipackage = orderData?.shipping_labels.filter(label => label.status == 'VALID' && label.label_type == 'Shipping').length > 0
      returnedOrder = orderData
      isInvalid = orderData?.status !== 'shipped' && !has_multipackage
      shouldReset = shouldResetSubmitData({ currentId: orderData?.id, heldId: submitData?.order_id, modified: modifiedSubmitData })
      dataExists = !!orderData
    }

    // console.log("returnData", returnData)
    if (!dataExists) {
      return
    }
    if (isInvalid) {
      setInvalidReturn(true)
    } else {
      setInvalidReturn(false)
      // console.log("returnData", returnData)
      if (shouldReset) {
        const orderProducts = []
        returnedOrder.order_lines.forEach(ol => {
          // console.log(ol.product)
          if (!ol.product) return
          if (ol.product.is_kit) {
            ol.product.kit_childs.forEach(kc => {
              orderProducts.push({
                product_id: kc.child_product.id,
                quantity: kc.quantity * ol.quantity,
                label: kc.child_product.name,
                sku: kc.child_product.product_codes.length > 0 ? kc.child_product.product_codes[0].sku : null,
                upc: kc.child_product.bar_code,
                damaged: false,
              })
            })
          } else {
            orderProducts.push({
              product_id: ol.product.id,
              quantity: ol.quantity,
              label: ol.product.name,
              sku: ol.product.product_codes.length > 0 ? ol.product.product_codes[0].sku : null,
              upc: ol.product.bar_code,
              damaged: false,
            })
          }
        })
        setIgnoreNextModifiedSubmitData(true)

        if (id !== undefined) {
          setSubmitData({
            ...submitData,
            return_id: returnData.id,
            return_tracking_number: returnData.returned_order?.return_label?.shipping_number,
            notes: returnData.notes,
            products: [],
          })
        } else if (orderId !== undefined) {
          setSubmitData({
            ...submitData,
            order_id: orderData.id,
            products: [],
          })
        }
      }
    }
  }, [returnData, orderData])

  // An order that can't take a return (never shipped, no valid shipping label) used to
  // dead-end on the "not eligible" message, leaving the operator with a package in hand
  // and no way forward — they had to trick the scan into missing the order to reach the
  // unidentified-return receipt. Send them there directly instead. Only for the order
  // entry point (orderId); receiving an existing return keeps its own message. Held until
  // the warehouse loads because where the flow is off there is nowhere to send them.
  useEffect(() => {
    if (!invalidReturn || id !== undefined || !orderData || !warehouse) return
    if (!isUnidentifiedReturnsEnabled(warehouse)) return

    history.replace(SEARCH_RETURN.replace(':scann_string', scannedString || orderData.order_number).replace(':warehouse_id', warehouse_id))
  }, [invalidReturn, id, orderData, warehouse, warehouse_id, scannedString, history])

  useEffect(() => {
    if (!modifiedSubmitData && !ignoreNextModifiedSubmitData) {
      // console.log("modified return data")
      setModifiedSubmitData(true)
    }
    setIgnoreNextModifiedSubmitData(false)
  }, [submitData])

  useEffect(() => {
    if (replenishmentInfo !== null) {
      setOpenDialogLabel(true)
    }
  }, [replenishmentInfo])

  const skipProductLotInReturns =
    !orderData && !returnData ? false : orderData ? orderData?.store?.skip_product_lot_in_returns : returnData?.store?.skip_product_lot_in_returns

  // product_id => [códigos únicos] the order shipped. The receive screen has a return to read it
  // from; the create-return screen does not (the return does not exist yet), so it reads the same
  // map off the order payload. Without the order fallback a scanned código único can never be
  // validated on that screen, because the list it is checked against is always empty there.
  const availableUnitCodes = returnData?.available_unit_codes || orderData?.available_unit_codes || {}

  useEffect(() => {
    if (orderData) {
      setReceiveOnlyCompleteReturns(orderData.store.receive_only_complete_returns)
    } else if (returnData) {
      setReceiveOnlyCompleteReturns(returnData.store.receive_only_complete_returns)
    }
  }, [orderData, returnData])

  // Return inspection gate: when enabled for the store and the return is not yet
  // AWAITING_INSPECTION, the operator must confirm all products are sealed before
  // scanning. Answering "no" moves the return to AWAITING_INSPECTION and sends it
  // to inspection. Reopening an already-AWAITING_INSPECTION return skips the gate.
  // Only applies to the receive-existing-return flow (id param).
  const returnInspectionEnabled = returnData?.store?.return_inspection_enabled
  const inspectionGateActive = returnInspectionEnabled && id !== undefined && !!returnData && returnData.status !== 'AWAITING_INSPECTION' && !sealedConfirmed

  const handleSealedYes = () => setSealedConfirmed(true)

  const handleSealedNo = async () => {
    try {
      setLoadingSubmit(true)
      // Going to inspection is the other way the first part ends: send the camera
      // snapshot and stop recording (the video already streamed to S3).
      await awaitInspection(id, buildReturnCameraStatus())
      dispatch(stopReturnRecording())
      setShowInspectionModal(true)
    } catch (error) {
      console.error(error)
      setNotificationMessage({ ...notificationMessage, show: true, title: t('returns.receive_return.await_inspection_failed') })
    } finally {
      setLoadingSubmit(false)
    }
  }

  const handleInspectionModalConfirm = () => {
    setShowInspectionModal(false)
    history.push(RETURNS.replace(':warehouse_id', warehouse_id))
  }

  const handleQuantityChange = (value, productIndex) => {
    // console.log("value:", value)
    // console.log("index:", productIndex)
    const products = submitData.products
    products[productIndex].quantity = value
    setSubmitData({ ...submitData, products: products })
  }

  const addDamagedProduct = productIndex => {
    const damagedProduct = {
      ...submitData.products[productIndex],
      damaged: true,
      quantity: 1,
    }
    const products = [...submitData.products]
    if (products[productIndex].quantity > 0) {
      products[productIndex].quantity -= 1
    }
    const foundIndex = submitData.products.findIndex(p => p.damaged && p.product_id === damagedProduct.product_id)
    if (foundIndex === -1) {
      products.push(damagedProduct)
    } else {
      products[foundIndex].quantity += 1
    }
    setSubmitData({ ...submitData, products: [...products] })
  }

  const removeSubmitableProduct = product => {
    let products = submitData.products
    products = products.filter(prod => prod.product_id != product.product_id)
    setSubmitData({
      ...submitData,
      products: products,
    })
  }

  const removeProduct = productIndex => {
    const products = [...foundProducts]
    products.splice(productIndex, 1)
    setFoundProducts(products)
    console.log('products', products)
    /*let products = [...submitData.products]
    products.splice(productIndex, 1)
    setSubmitData({ ...submitData, products: [...products] })*/
  }

  /*const addProduct = (productDataArray) => {
    // console.log(productDataArray)
    let products = [...submitData.products]
    productDataArray.forEach((productData) => {
      let productsToAdd = []
      if (productData.is_kit && productData.kit_childs) {
        productData.kit_childs.forEach((kc) => {
          for (let index = 0; index < kc.quantity; index++) {
            productsToAdd.push({ ...kc.child_product })
          }
        })
      } else {
        productsToAdd.push({ ...productData })
      }
      // console.log("productsToAdd", productsToAdd)
      productsToAdd.forEach((productToAdd) => {
        let foundIndex = products.findIndex(
          (p) => !p.damaged && p.product_id === productToAdd.id
        )
        if (foundIndex === -1) {
          products.push({
            product_id: productToAdd.id,
            quantity: 1,
            label: productToAdd.name,
            sku:
              productToAdd.product_codes.length > 0
                ? productToAdd.product_codes[0].sku
                : null,
            upc: productToAdd.bar_code,
            damaged: false,
          })
        } else {
          products[foundIndex].quantity += 1
        }
      })
    })
    setSubmitData({ ...submitData, products: [...products] })
    setShowSelectReturnedProductDialog(false)
  }*/

  const totalProductItems = useMemo(() => {
    let count = 0
    count = submitData.products.reduce((total, product) => total + product.quantity + product.quantity_damaged, 0)
    return count
  }, [submitData])

  const uniqueSubmitableProducts = useMemo(() => {
    const submitableProducts = []
    submitData.products.map(product => {
      if (submitableProducts.findIndex(submitableProduct => submitableProduct.product_id == product.product_id) < 0) submitableProducts.push(product)
    })
    return submitableProducts
  }, [submitData])

  const onSubmitConfirm = async ({ confirmAllMissing = false } = {}) => {
    const data = {
      ...submitData,
    }

    // Remove unused fields, according to the operation type: Receiving or Creating return, and ensure contains IDs
    if (returnData && returnData.return_type != 'RETURNED_BY_CARRIER') {
      delete data.notes
    }
    if (id !== undefined) {
      delete data.order_id

      data.return_id = returnData.id
    } else if (orderId !== undefined) {
      delete data.return_id

      data.order_id = orderData.id
    }

    // Expected products the operator never scanned are auto-flagged missing (confirmed in the save
    // dialog). Each is shaped like a manual "Faltante" entry so the shared transform below emits a
    // { missing: true } row; unit-code products carry the exact códigos únicos that never arrived.
    const autoMissingProducts = missingProductEntries.map(({ product, missing, unitCodes }) => ({
      product_id: product.id,
      label: product.name,
      sku: product.product_codes?.length > 0 ? product.product_codes[0].sku : null,
      upc: product.bar_code,
      requires_unit_code: !!product.requires_unit_code,
      quantity: 0,
      quantity_damaged: 0,
      quantity_missing: missing,
      is_missing: true,
      damaged: false,
      selected_lot: null,
      unit_codes_missing: unitCodes,
    }))

    const products = []
    ;[...data.products, ...autoMissingProducts].forEach(product => {
      // Missing entries are lot-agnostic and never physically arrived: send one missing row
      // carrying the flagged IMEIs (if any), so the backend relocates those exact shipped units.
      if (product.is_missing) {
        const missing_product = { ...product, quantity: product.quantity_missing, damaged: false, missing: true, selected_lot: null }
        if (product.requires_unit_code) missing_product.unit_codes = product.unit_codes_missing || []
        products.push(missing_product)
        return
      }

      if (product.quantity_damaged > 0) {
        const damaged_product = { ...product, quantity: product.quantity_damaged, damaged: true }
        // Each split entry carries only its own IMEIs (damaged vs good) so the count
        // matches its quantity, never mixing the two sets.
        if (product.requires_unit_code) damaged_product.unit_codes = product.unit_codes_damaged || []
        products.push(damaged_product)

        if (product.quantity > 0) {
          const good_product = {
            ...product,
            damaged: false,
          }
          if (product.requires_unit_code) good_product.unit_codes = product.unit_codes || []
          products.push(good_product)
        }
      } else {
        products.push(product)
      }
    })
    data.products = products

    // Receiving a return where nothing arrived closes it as UNSUCCESSFUL and writes every unit off,
    // with no undo. The generic dialog shows on every save, so it can't stand as consent: the
    // payload is only sent with confirm_all_missing from the dedicated dialog (BUGS-8974). The
    // check runs here, at send time, so no path reaches the platform without that dialog.
    // createReturn needs none of this: the platform refuses an all-missing creation outright.
    if (id !== undefined && isAllMissingReceipt(data.products)) {
      if (!confirmAllMissing) {
        setAllMissingProducts(summarizeMissingProducts(data.products))
        setAllMissingPending(true)
        setShowConfirmDialog(false)
        return
      }
      data.confirm_all_missing = true
    }

    const returnCameraStatus = buildReturnCameraStatus()
    if (returnCameraStatus) data.camera_status = returnCameraStatus
    setLoadingSubmit(true)
    try {
      let response = null
      if (id !== undefined) {
        response = await receiveReturn(id, data)
      } else if (orderId !== undefined) {
        response = await createReturn(data)
      }
      if (response) {
        setReplenishmentInfo(response)
      }
      // Stopping flushes the last chunk and completes the S3 multipart upload. Whether the video is
      // shown is decided by the platform, from the camera snapshot sent with the receipt.
      dispatch(stopReturnRecording())
      setModifiedSubmitData(false)
      setIgnoreNextModifiedSubmitData(true)
      setShowConfirmDialog(false)
      setAllMissingProducts(null)
    } catch (error) {
      console.error(error)
      // Surface the backend's actionable code/message (CUBBO-2190) instead of the
      // raw Axios "Request failed with status code 422" string.
      setNotificationMessage({
        ...notificationMessage,
        show: true,
        type: 'error',
        title: resolveReturnReceiveErrorMessage(error, t),
      })
    }
    setLoadingSubmit(false)
  }

  // Save stays enabled and refuses with a reason, instead of a disabled button that never says why.
  // Two refusals. Scanned products sitting in the buffer are physically present but not yet
  // categorized, so saving there would silently drop them. And a reception with nothing booked at
  // all has nothing to confirm: with the auto flag on, confirming it would write off the whole
  // order in two clicks, which is the one gesture this screen must not make cheap. Registering a
  // parcel that arrived empty stays possible and stays deliberate, by naming each SKU and marking
  // it faltante, which books it. Expected products that were never scanned are handled separately:
  // the confirm dialog lists them and flags them missing on confirm.
  const handleSaveClick = () => {
    if (foundProducts.length > 0) {
      setNotificationMessage({
        ...notificationMessage,
        show: true,
        title: t('returns.receive_return.resolve_scanned_products_first'),
      })
      return
    }
    if (submitData.products.length === 0) {
      setNotificationMessage({
        ...notificationMessage,
        show: true,
        title: t('returns.receive_return.nothing_booked_to_save'),
      })
      return
    }
    setShowConfirmDialog(true)
  }

  const searchProductInReturnLocally = sku => {
    let expectedProducts = []
    let expectedProductsKits = []
    if (id !== undefined) {
      expectedProducts = returnData.returned_order.order_lines.filter(line => line?.product?.is_kit === false).map(line => line.product)
      expectedProductsKits = returnData.returned_order.order_lines
        .filter(line => line?.product?.is_kit === true)
        .flatMap(line => line.product.kit_childs.map(kit_child => kit_child.child_product))
    } else if (orderId !== undefined) {
      expectedProducts = orderData.order_lines.filter(line => line?.product?.is_kit === false).map(line => line.product)
      expectedProductsKits = orderData.order_lines
        .filter(line => line?.product?.is_kit === true)
        .flatMap(line => line.product.kit_childs.map(kit_child => kit_child.child_product))
    }
    expectedProducts = expectedProducts.concat(expectedProductsKits)
    const foundProduct = expectedProducts.find(product => product.bar_code == sku || product.product_codes.map(code => code.sku).includes(sku))
    if (foundProduct) return { products: [foundProduct] }
    else return null
  }

  // Expected products the operator never scanned: the shortfall between what this return is
  // expected to receive and everything already booked (received good + damaged + manually-flagged
  // missing). These are auto-flagged missing on save, after the operator confirms the dialog.
  //
  // The baseline is the RETURN's expected_products whenever it has them. A customer- or
  // brand-requested return declares which items are coming back, so an order line the customer
  // kept must never be flagged as missing. Carrier returns carry no expected_products because the
  // whole package came back, so there the order lines are the expectation. Anything else, a return
  // with no declaration that is not a carrier return, flags nothing: there is no basis for it.
  //
  // Kits are expanded to their child products so the ids match how received entries are keyed, and
  // unit-code products carry the exact códigos únicos that never arrived (all of the order's
  // shipped codes for that product that weren't already used), so the backend relocates the right
  // units.
  const missingProductEntries = useMemo(() => {
    // This deliberately runs for every store, which the warning it replaces did not: that one was
    // gated on skip_product_lot_in_returns, a lot-selection flag it had no relation to, and in
    // production only four stores carry it, all Natura, none of which receives through the
    // create-return route. Inheriting that gate would leave the feature switched off exactly where
    // the losses were reported. The scope that does the work is the one below, expected products,
    // carrier return and scannability, not a store flag about lots.
    const orderLines = orderData ? orderData.order_lines : returnData?.returned_order?.order_lines
    if (!orderLines) return []

    const expected = {}
    // A channel SKU that was never mapped leaves the line without a product. This memo runs on
    // every render, before any eligibility guard, so an unguarded read throws during render and
    // unmounts the whole app (there is no ErrorBoundary).
    // Non-scannable products are packaging and inserts: the box, the seal sticker, the thank-you
    // card. They ride along on the order line and never physically come back, so an expected minus
    // scanned rule flags them on every single reception. Flagging them wrote off stock nobody was
    // ever going to return, and it trained operators to confirm the whole list without reading it.
    // ReturnSerializer#return_products already excludes them from the receivable set for the same
    // reason, so this keeps the screen and the payload on the same definition of what can come back.
    const isReturnable = product => product && product.is_scannable !== false

    const addExpected = (product, quantity) => {
      if (!product || !(quantity > 0)) return
      if (product.is_kit) {
        ;(product.kit_childs || []).forEach(kc => {
          const pid = kc.child_product?.id
          if (!pid || !isReturnable(kc.child_product)) return
          if (!expected[pid]) expected[pid] = { product: kc.child_product, quantity: 0 }
          expected[pid].quantity += kc.quantity * quantity
        })
      } else {
        if (!isReturnable(product)) return
        if (!expected[product.id]) expected[product.id] = { product, quantity: 0 }
        expected[product.id].quantity += quantity
      }
    }

    const declaredProducts = returnData?.expected_products
    // On the receive route the loaded return answers this, and while it is still loading it reads
    // false, which flags nothing.
    //
    // On the create-return route there is no return yet, so the screen has to classify the arrival
    // the same way the endpoint that will create it does. A prepaid return guide that shipped
    // inside the outbound package and came back carrying the number the operator scanned means the
    // CUSTOMER chose what to send: the order lines are not the expectation and nothing may be
    // flagged. Anything else arriving with no return on file is the carrier handing the parcel
    // back undelivered, where the whole package is expected. Only the scanned number separates the
    // two, because a prepaid guide that was never used still rides inside a parcel the carrier
    // returns. The order payload surfaces that guide as return_label; its label_type is the
    // backend's LABEL_TYPE_RETURN_PREPAID.
    const scannedPrepaidReturn =
      orderData?.return_label?.label_type === 'Return Prepaid' && orderData?.return_label?.shipping_number === submitData.return_tracking_number
    const isCarrierReturn = orderId !== undefined ? !scannedPrepaidReturn : returnData?.return_type === 'RETURNED_BY_CARRIER'

    if (declaredProducts && declaredProducts.length > 0) {
      declaredProducts.forEach(declared => {
        const line = orderLines.find(l => l.product?.id === declared.product_id)
        addExpected(line?.product, declared.quantity || 0)
      })
    } else if (isCarrierReturn) {
      orderLines.forEach(line => addExpected(line.product, line.quantity))
    } else {
      // No declaration and not a carrier return: there is nothing to base an expectation on, so
      // flag nothing rather than assume the whole order was coming back.
      return []
    }

    const received = {}
    const usedCodes = new Set()
    submitData.products.forEach(p => {
      received[p.product_id] = (received[p.product_id] || 0) + (p.quantity || 0) + (p.quantity_damaged || 0) + (p.quantity_missing || 0)
      ;(p.unit_codes || []).forEach(c => usedCodes.add(c))
      ;(p.unit_codes_damaged || []).forEach(c => usedCodes.add(c))
      ;(p.unit_codes_missing || []).forEach(c => usedCodes.add(c))
    })

    const entries = []
    Object.entries(expected).forEach(([pid, { product, quantity }]) => {
      const receivedQty = received[pid] || 0
      const missing = quantity - receivedQty
      if (missing > 0) {
        const unitCodes = product.requires_unit_code ? (availableUnitCodes[String(pid)] || []).filter(c => !usedCodes.has(c)) : []
        entries.push({ product, expected: quantity, received: receivedQty, missing, unitCodes })
      }
    })
    return entries
  }, [submitData, orderData, returnData])

  const missingProducts = useMemo(() => {
    if (!showConfirmDialog || missingProductEntries.length === 0) return ''

    let message = `<br></br><div>${t('returns.receive_return.missing_products_header')}</div><div style="margin-left: 10px;">`
    missingProductEntries.forEach(({ product, expected, received }) => {
      const displayName = product?.name || ''
      const displayUpc = product?.bar_code || product?.product_codes?.[0]?.sku || t('returns.receive_return.no_upc')
      message += `${displayName}<br>
        <span style="color: red;">${displayUpc} - ${t('returns.receive_return.expected')}: ${expected}, ${t('returns.receive_return.received')}: ${received}</span><br>`
    })
    message += '</div>'

    return message
  }, [showConfirmDialog, missingProductEntries])

  const allMissingDescription = useMemo(() => {
    if (!allMissingProducts) return ''

    let message = `<div>${t('returns.receive_return.all_missing_description')}</div><br></br><div>${t('returns.receive_return.all_missing_products_header')}</div><div style="margin-left: 10px;">`
    // Catalog names go into an HTML string, so escape them; the copy around them is ours.
    allMissingProducts.forEach(({ label, upc, sku, quantity }) => {
      message += `${escape(label || '')}<br>
        <span style="color: red;">${escape(upc || sku || t('returns.receive_return.no_upc'))} - ${t('returns.receive_return.all_missing_quantity', { quantity })}</span><br>`
    })
    message += `</div><br></br><div><strong>${t('returns.receive_return.all_missing_irreversible')}</strong></div>`

    return message
  }, [allMissingProducts])

  const handleSearchChange = async val => {
    console.log('Search changed')
    setProductsNotFound(false)
    setProductsNotFoundInOrder(false)
    setproductSearchIsLoading(true)
    let search_res = null
    if (val !== '') {
      //If product is already in counting process, don't look for it again in the API
      search_res = searchProductInReturnLocally(val)
      console.log('warehouse', warehouse)
      if (search_res === null && warehouse.country == 'BR') {
        setProductsNotFoundInOrder(true)
        setproductSearchIsLoading(false)
        return null
      }

      if (search_res === null) {
        const storeId = id !== undefined ? returnData?.returned_order?.store.id : orderData.store.id
        search_res = await fetchProductsBySkyOrUpc({ search: val, is_kit: false, store_id: storeId })
      }

      console.log('search_res')
      console.log(search_res)

      setproductSearchIsLoading(false)
      if (search_res === null || search_res.products.length != 1) {
        //setFoundProduct(null)
        setExists(false)
        if (val === '') {
          setProductsNotFound(false)
        }
        console.log('val', val)
        setProductsNotFound(true)
        setLastScannedProduct({ id: 0 })
      } else {
        const foundProduct = search_res.products[0]
        let lots = []
        if (!skipProductLotInReturns && foundProduct.has_expiration) lots = await fetchProductLots(foundProduct.id)
        lots.map(l => {
          l.value = l.unique_code
          l.label = l.unique_code
        })
        if (lastScannedProduct.id != foundProduct) {
          /*let scannedProductLots = data.replenishment.lots.filter(lot => lot.product_id === search_res.product.id)
                if(!scannedProductLots.map(lot => lot.id).includes(activeLot))
                    setActiveLot(null)*/
        }
        setLastScannedProduct(foundProduct)
        if (search_res.exists && search_res.exists === true) {
          setExists(true)
        } else {
          setExists(false)
        }
        const newFoundProducts = [...foundProducts]
        if (foundProducts.findIndex(product => product.product_id == foundProduct.id) == -1) {
          newFoundProducts.push({
            id: foundProduct.id,
            product_id: foundProduct.id,
            product_codes: foundProduct.product_codes,
            quantity: 0,
            quantity_damaged: 0,
            quantity_missing: 0,
            label: foundProduct.name,
            sku: foundProduct.product_codes.length > 0 ? foundProduct.product_codes[0].sku : null,
            upc: foundProduct.bar_code,
            has_expiration: foundProduct.has_expiration,
            damaged: false,
            product_image_path: foundProduct.product_image_path,
            lots: lots,
            selected_lot: null,
            selecting_lot: false,
            requires_unit_code: foundProduct.requires_unit_code,
            selected_unit_code: null,
          })
        } else {
          /*let availableLots = data.replenishment.lots.filter(lot => lot.product_id === search_res.product.id)
                let newActiveLot = activeLot
                if(availableLots.length == 1){
                    newActiveLot = availableLots[0].id
                    setActiveLot(newActiveLot)
                }
                let foundProductIndex = newFoundProducts.findIndex(product => product.id === search_res.product.id && newActiveLot == product.lot?.id)
                if(foundProductIndex == -1){
                    alert("Éste producto tiene más de un lote, selecciona uno para continuar")
                }else{
                    newFoundProducts[foundProductIndex].insertQuantity += 1
                    //animate()
                }*/
        }
        setProductsNotFound(false)
        setFoundProducts(newFoundProducts)
        searchInputRef.current?.resetInput()
      }
      setproductSearchIsLoading(false)
    }
  }

  const handleAddToReturnData = (product, index, damaged = false, missing = false) => {
    // Unit-code products (Oppo): the operator must pick the código único of this unit — the IMEI of
    // the physical unit when receiving/damaging, or the exact one from the order when flagging it
    // missing (so the backend relocates that specific shipped unit). Either way a code is required.
    if (product.requires_unit_code && !product.selected_unit_code) {
      setNotificationMessage({ ...notificationMessage, show: true, title: t('returns.receive_return.select_unit_code_first') })
      return
    }

    const submitableProducts = cloneDeep(submitData.products)
    const submitableProductIndex = submitableProducts.findIndex(submitableProduct => {
      // Missing is lot-agnostic (the unit never arrived): it lives in its own per-product entry and
      // must never match — or deref the lot of — a lot-keyed receive/damaged entry.
      if (missing) return submitableProduct.is_missing && submitableProduct.product_id == product.product_id
      if (submitableProduct.is_missing) return false
      return skipProductLotInReturns || !submitableProduct.has_expiration
        ? submitableProduct.product_id == product.product_id
        : submitableProduct.product_id == product.product_id && product.selected_lot.unique_code == submitableProduct.selected_lot.unique_code
    })

    let productToSubmit = null

    if (submitableProductIndex == -1) {
      productToSubmit = product

      if (missing) {
        product.quantity = 0
        product.quantity_damaged = 0
        product.quantity_missing = 1
        product.is_missing = true
        product.selected_lot = null
        if (product.requires_unit_code) {
          product.unit_codes = []
          product.unit_codes_damaged = []
          product.unit_codes_missing = [product.selected_unit_code]
        }
      } else {
        if (damaged) product.quantity_damaged = 1
        else product.quantity = 1
        if (product.requires_unit_code) {
          product.unit_codes = []
          product.unit_codes_damaged = []
          if (damaged) product.unit_codes_damaged.push(product.selected_unit_code)
          else product.unit_codes.push(product.selected_unit_code)
        }
      }
      submitableProducts.push(product)
    } else {
      productToSubmit = submitableProducts[submitableProductIndex]
      const entry = submitableProducts[submitableProductIndex]

      if (missing) {
        entry.quantity_missing = (entry.quantity_missing || 0) + 1
        if (product.requires_unit_code) {
          if (!entry.unit_codes_missing) entry.unit_codes_missing = []
          entry.unit_codes_missing.push(product.selected_unit_code)
        }
      } else if (damaged) {
        entry.quantity_damaged++
        if (product.requires_unit_code) {
          if (!entry.unit_codes_damaged) entry.unit_codes_damaged = []
          entry.unit_codes_damaged.push(product.selected_unit_code)
        }
      } else {
        entry.quantity++
        if (product.requires_unit_code) {
          if (!entry.unit_codes) entry.unit_codes = []
          entry.unit_codes.push(product.selected_unit_code)
        }
      }
    }

    if (receiveOnlyCompleteReturns) {
      const orderLines = orderData ? orderData.order_lines : returnData.returned_order.order_lines
      let expectedProductQuantity = 0

      orderLines.forEach(orderLine => {
        if (orderLine.product?.id === productToSubmit.product_id) {
          expectedProductQuantity += orderLine.quantity
        }
      })

      // Account for everything booked against this product across its entries — received good,
      // received damaged, and flagged missing — so the operator can't exceed the shipped quantity.
      const totalReceivedQuantity = submitableProducts
        .filter(p => p.product_id == productToSubmit.product_id)
        .reduce((total, p) => total + (p.quantity || 0) + (p.quantity_damaged || 0) + (p.quantity_missing || 0), 0)

      if (totalReceivedQuantity > expectedProductQuantity) {
        const errorTitle = i18n.t('returns.errors.received_more_products_than_expected', { quantity: expectedProductQuantity, upc: productToSubmit.upc })
        setNotificationMessage({ ...notificationMessage, show: true, title: errorTitle })
        return
      }
    }

    if (id !== undefined) {
      setSubmitData({
        ...submitData,
        return_id: returnData.id,
        products: submitableProducts,
      })
    } else if (orderId !== undefined) {
      setSubmitData({
        ...submitData,
        order_id: orderData.id,
        products: submitableProducts,
      })
    }

    removeProduct(index)
  }

  const resetSearch = async () => {
    setProductsNotFound(false)
    setTextToSearch('')
  }

  const setSelectingLotMode = index => {
    const prods = [...foundProducts]
    prods[index].selecting_lot = true
    setFoundProducts(prods)
  }

  const removeSelectedLot = index => {
    const prods = [...foundProducts]
    prods[index].selected_lot = null
    prods[index].selecting_lot = false
    setFoundProducts(prods)
  }

  const setSelectedLot = (lot, index) => {
    const prods = [...foundProducts]
    prods[index].selected_lot = lot
    setFoundProducts(prods)
  }

  const removeSelectedUnitCode = index => {
    const prods = [...foundProducts]
    prods[index].selected_unit_code = null
    setFoundProducts(prods)
  }

  // IMEIs already consumed (added to a received entry or currently picked in another
  // found-product row), so the same IMEI can't be selected twice.
  const usedUnitCodes = useMemo(() => {
    const used = new Set()
    submitData.products.forEach(p => {
      ;(p.unit_codes || []).forEach(c => used.add(c))
      ;(p.unit_codes_damaged || []).forEach(c => used.add(c))
      ;(p.unit_codes_missing || []).forEach(c => used.add(c))
    })
    foundProducts.forEach(p => {
      if (p.selected_unit_code) used.add(p.selected_unit_code)
    })
    return used
  }, [submitData, foundProducts])

  // Validates a scanned IMEI (fired on debounced change, like the SKU search): it must
  // be one of the order's shipped IMEIs for this product and not already used. On
  // success it becomes the unit's selected_unit_code.
  const handleUnitCodeScan = (rawValue, index) => {
    const code = (rawValue || '').trim()
    if (!code) return

    const product = foundProducts[index]
    const available = availableUnitCodes[String(product.product_id)] || []
    if (!available.includes(code)) {
      setNotificationMessage({ ...notificationMessage, show: true, title: t('returns.receive_return.unit_code_not_for_product') })
      return
    }
    if (usedUnitCodes.has(code)) {
      setNotificationMessage({ ...notificationMessage, show: true, title: t('returns.receive_return.unit_code_already_used') })
      return
    }

    const prods = [...foundProducts]
    prods[index].selected_unit_code = code
    setFoundProducts(prods)
  }

  const handleCreateLot = product => {
    console.log('product', product)
    console.log('returndata', returnData)
    setProductToCreateLot(product)
    setShowCreateLotsDialog(true)
  }

  const isDamaged = product => {
    if (id !== undefined) {
      return (
        returnData.expected_products &&
        returnData.expected_products.filter(expectedProduct => expectedProduct.product_id == product.id && expectedProduct.damaged === true).length != 0
      )
    } else if (orderId !== undefined) {
      return false
    }
  }

  const disableReceiveButton = product =>
    (!skipProductLotInReturns && product.has_expiration && !product.selected_lot) ||
    isDamaged(product) ||
    (product.requires_unit_code && !product.selected_unit_code)

  const disableDamagedButton = product =>
    (!skipProductLotInReturns && product.has_expiration && !product.selected_lot) || (product.requires_unit_code && !product.selected_unit_code)

  // Missing units never arrived, so no lot is required; for unit-code products the operator must
  // still pick the exact código único from the order so the backend relocates that specific unit.
  const disableMissingButton = product => product.requires_unit_code && !product.selected_unit_code

  return (
    <>
      {id !== undefined && cameraRecordingRequired && (
        <ReturnCameraRecorder />
      )}
      <PageView
        className="bg-black"
        topMenu={
          <PageTopBar>
            <div className="text-lg font-semibold">
              {id !== undefined && returnData ? (
                <>
                  <a
                    className="text-gray-400"
                    onClick={() => {
                      history.push(RETURNS.replace(':warehouse_id', warehouse_id))
                    }}
                  >
                    {t('returns.receive_return.returns_breadcrumb')}
                  </a>
                  {returnData.return_type == 'RETURNED_BY_CARRIER' ? (
                    <>{t('returns.receive_return.page_title_receive_by_courier')}</>
                  ) : (
                    <>{t('returns.receive_return.page_title_receive_order')}</>
                  )}
                </>
              ) : (
                <>
                  <a
                    className="text-gray-400"
                    onClick={() => {
                      history.push(ORDERS_SHIPPED.replace(':warehouse_id', warehouse_id))
                    }}
                  >
                    Envios →
                  </a>{' '}
                  Crear Retorno
                </>
              )}
            </div>
          </PageTopBar>
        }
        childrenFullWidth={true}
        topMenuFullWidth={true}
      >
        {isLoading || orderIsLoading ? (
          <>
            <Loader show={true}></Loader>
          </>
        ) : isError || orderIsError ? (
          <>Error: {isError ? error.message : orderError.message}</>
        ) : invalidReturn ? (
          <>
            {id !== undefined ? (
              <>Error: Este retorno no se puede recibir. ({getStatusDefinition(returnData.status, RETURNS_STATUSES).label})</>
            ) : (
              <>Error: La orden se encuentra en un estado no elegible para retorno. ({getStatusDefinition(orderData.status, ORDER_STATUSES).label})</>
            )}
          </>
        ) : (
          <div>
            <div className="">
              <dl>
                <div className="even:bg-gray-50 bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">Número de orden</dt>
                  {id !== undefined ? (
                    <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                      <a
                        onClick={() => {
                          history.push(
                            SHOW_RECEIVING_ORDER.replace(':returnId', id).replace(':warehouse_id', warehouse_id).replace(':id', returnData.returned_order.id),
                          )
                        }}
                      >
                        #{returnData.returned_order.order_number}
                      </a>
                    </dd>
                  ) : (
                    <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                      <a
                        onClick={() => {
                          history.push(
                            SHOW_CREATING_RETURN_ORDER.replace(':orderId', orderData.id).replace(':warehouse_id', warehouse_id).replace(':id', orderData.id),
                          )
                        }}
                      >
                        #{orderData.order_number}
                      </a>
                    </dd>
                  )}
                </div>
                <div className="even:bg-gray-50 bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">Tienda</dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    {id !== undefined ? returnData.returned_order.store.name : orderData.store.name}
                  </dd>
                </div>
                <div className="even:bg-gray-50 bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">Tipo de Retorno</dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    {getReturnTypeDefinition(id !== undefined ? returnData.return_type : 'RETURNED_BY_CARRIER').label}
                  </dd>
                </div>
                <div className="even:bg-gray-50 bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">Guía de retorno</dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    {returnData && returnData.returned_order && returnData.returned_order.return_label ? (
                      returnData.returned_order.return_label.shipping_number
                    ) : (
                      <InputField
                        className="sm:col-span-3"
                        title={t('returns.receive_return.return_label_title')}
                        onChange={val => setSubmitData({ ...submitData, return_tracking_number: val })}
                      />
                    )}
                  </dd>
                </div>
                <div className="even:bg-gray-50 bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">Notas</dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    {id !== undefined && returnData && returnData.return_type != 'RETURNED_BY_CARRIER' ? (
                      submitData.notes
                    ) : (
                      <TextareaField value={submitData.notes} onChange={val => setSubmitData({ ...submitData, notes: val })} />
                    )}
                  </dd>
                </div>
                {inspectionGateActive && (
                  <div className="bg-white px-4 py-8 sm:px-6 text-center">
                    <div className="text-lg font-bold mb-6">{t('returns.receive_return.all_sealed_question')}</div>
                    <div className="flex gap-3 justify-center">
                      <Button type="primary" disabled={loadingSubmit} onClick={handleSealedYes}>
                        {t('returns.receive_return.all_sealed_yes')}
                      </Button>
                      <Button type="secondary" disabled={loadingSubmit} onClick={handleSealedNo}>
                        {t('returns.receive_return.all_sealed_no')}
                      </Button>
                    </div>
                  </div>
                )}
                {!inspectionGateActive && (
                  <>
                    <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                      <dd className="mt-1 text-sm text-gray-400 sm:mt-0 sm:col-span-3">
                        <div className="text-lg font-bold mb-4">Escanea para recibir los productos retornados</div>
                        <div className="mb-10 text-gray-500">También deberás registrar a qué lote pertenece (en caso de ser un producto con lote).</div>
                      </dd>
                      <dd className="mt-1 text-sm text-gray-400 sm:mt-0 sm:col-span-1">
                        <SearchInput
                          debounce="30"
                          dependencies={[foundProducts, submitData]}
                          inputValue={textToSearch}
                          className="w-full my-2"
                          onChange={handleSearchChange}
                          onReset={() => {
                            resetSearch()
                          }}
                          ref={searchInputRef}
                        />
                      </dd>
                      <dd className="mt-1 pt-4 text-sm text-gray-400 sm:mt-0 sm:col-span-2">
                        {messageProductsNotFound && t('returns.receive_return.no_products_found')}
                        {messageProductsNotFoundInOrder && t('returns.receive_return.product_not_in_order')}
                      </dd>
                    </div>
                    <div className="bg-white pb-5 w-full">
                      <div className="w-full text-left">
                        <div className="bg-gray-50 px-6">
                          <div className="text-gray-500 uppercase grid grid-cols-12">
                            <div className="py-3">Imagen</div>
                            <div className="py-3 col-span-2">Producto</div>
                            <div className="col-span-2 py-3">UPC</div>
                            <div className="col-span-2 py-3">SKU</div>
                            <div className="col-span-2 py-3">Lote</div>
                            <div className="py-3">{t('returns.receive_return.returned_undamaged_pieces')}</div>
                            <div className="py-3">{t('returns.receive_return.returned_damaged_pieces')}</div>
                          </div>
                        </div>

                        <div className="p-3">
                          {foundProducts.map((product, index) => (
                            <div
                              className="text-gray-500 grid grid-cols-12 border rounded-lg mb-3"
                              key={product.damaged ? String(product.product_id) + 'D' : String(product.product_id)}
                            >
                              <div className="p-3 py-6">
                                <TableImage
                                  thumbnail_image={product.product_image_path?.thumbnail_path}
                                  regular_image={product.product_image_path?.path}
                                ></TableImage>
                              </div>
                              <div className="p-3 py-6 col-span-2">
                                {product.label} {product.damaged && <i className="text-red-500">{t('returns.receive_return.damaged_pieces')}</i>}
                              </div>
                              <div className="col-span-2 py-6">{product.upc ? product.upc : t('returns.receive_return.no_upc')}</div>
                              <div className="col-span-2 py-6">
                                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 mx-1">
                                  {product.sku}
                                </span>
                                {product.requires_unit_code && (
                                  <div className="mt-2 mr-2">
                                    {product.selected_unit_code ? (
                                      <div className="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium bg-blue-800 text-white mx-1">
                                        {product.selected_unit_code}
                                        <a onClick={() => removeSelectedUnitCode(index)}>
                                          <XIcon className="text-white ml-1 h-4 w-4" aria-hidden="true" />
                                        </a>
                                      </div>
                                    ) : (
                                      <SearchInput
                                        debounce="30"
                                        // Without dependencies the debounced onChange is captured on first
                                        // render and goes stale: scanning a code would rewrite foundProducts
                                        // from an old snapshot, dropping other scanned products. Mirror the
                                        // SKU search above so the closure stays fresh.
                                        dependencies={[foundProducts, submitData]}
                                        className="w-11/12"
                                        placeholder={t('returns.receive_return.scan_unit_code_placeholder')}
                                        onChange={val => handleUnitCodeScan(val, index)}
                                      />
                                    )}
                                  </div>
                                )}
                              </div>
                              <div className="py-6 col-span-2">
                                {!skipProductLotInReturns && product.has_expiration ? (
                                  <>
                                    {product.selected_lot && (
                                      <div className="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium bg-blue-800 text-white mx-1">
                                        {product.selected_lot.unique_code}
                                        <a onClick={() => removeSelectedLot(index)}>
                                          <XIcon className="text-white ml-1 h-4 w-4" aria-hidden="true" />
                                        </a>
                                      </div>
                                    )}
                                    {!product.selected_lot && (
                                      <button
                                        onClick={() => setSelectingLotMode(index)}
                                        className="rounded-xl border-4 items-center border-gray-400 w-4/5 p-3 text-md mb-4"
                                      >
                                        Selecciona o crea el lote del producto retornado.
                                      </button>
                                    )}
                                    {!product.selected_lot && product.selecting_lot && (
                                      <AutoComplete
                                        dropdownClassName=""
                                        className="w-full rounded-t-xl border-2 border-gray-400 bg-gray-100"
                                        defaultActiveFirstOption={false}
                                        options={product.lots}
                                        autoFocus={true}
                                        filterOption={true}
                                        onSelect={(value, option) => {
                                          setSelectedLot(option, index)
                                        }}
                                        notFoundContent={
                                          <Button className="px-2 has-tooltip" dense onClick={() => handleCreateLot(product)}>
                                            <span className="tooltip rounded shadow-lg p-1.5 bg-black text-white -mt-12">
                                              {t('returns.receive_return.lot_tooltip')}
                                            </span>
                                            {t('returns.receive_return.create_new_lot')}
                                          </Button>
                                        }
                                      >
                                        <Input
                                          size="large"
                                          bordered={false}
                                          placeholder={t('returns.receive_return.search_lot_placeholder')}
                                          className="placeholder-black"
                                          prefix={<SearchIcon className="text-black mr-1 h-4 w-4" aria-hidden="true" />}
                                        />
                                      </AutoComplete>
                                    )}
                                  </>
                                ) : (
                                  t('returns.receive_return.no_lot_required')
                                )}
                              </div>
                              <div className="py-6">
                                <Button
                                  className={`px-2 ${disableReceiveButton(product) ? 'has-tooltip' : ''}`}
                                  dense
                                  disabled={disableReceiveButton(product)}
                                  onClick={() => handleAddToReturnData(product, index)}
                                >
                                  <span className="tooltip rounded shadow-lg p-1.5 bg-black text-white -mt-12">
                                    {isDamaged(product) ? (
                                      t('returns.receive_return.product_marked_damaged')
                                    ) : product.has_expiration ? (
                                      <>{t('returns.receive_return.select_lot_first')}</>
                                    ) : (
                                      ''
                                    )}
                                  </span>
                                  {t('returns.receive_return.receive')}
                                </Button>
                              </div>
                              <div className="py-6">
                                <Button
                                  className="px-2 has-tooltip"
                                  disabled={disableDamagedButton(product)}
                                  dense
                                  type="danger"
                                  onClick={() => handleAddToReturnData(product, index, true)}
                                >
                                  {product.has_expiration && !product.selected_lot && (
                                    <span className="tooltip rounded shadow-lg p-1.5 bg-black text-white -mt-12">
                                      {t('returns.receive_return.select_lot_first')}
                                    </span>
                                  )}
                                  {t('returns.receive_return.damaged')}
                                </Button>
                              </div>
                              <div className="py-6">
                                <Button
                                  className={`px-2 ${disableMissingButton(product) ? 'has-tooltip' : ''}`}
                                  disabled={disableMissingButton(product)}
                                  dense
                                  type="secondary"
                                  onClick={() => handleAddToReturnData(product, index, false, true)}
                                >
                                  {disableMissingButton(product) && (
                                    <span className="tooltip rounded shadow-lg p-1.5 bg-black text-white -mt-12">
                                      {t('returns.receive_return.select_unit_code_first')}
                                    </span>
                                  )}
                                  {t('returns.receive_return.missing')}
                                </Button>
                              </div>
                              <div className="py-6 text-right pr-3">
                                <Button className="px-2 has-tooltip ml-2" dense type="secondary" onClick={() => removeProduct(index)}>
                                  <span className="tooltip rounded shadow-lg p-1.5 bg-black text-white -mt-12">
                                    {t('returns.receive_return.remove_product')}
                                  </span>
                                  <TrashIcon className="w-4 h-4" />
                                </Button>
                              </div>
                            </div>
                          ))}
                          {productSearchIsLoading && <Skeleton active title={false}></Skeleton>}
                        </div>
                      </div>
                    </div>
                  </>
                )}

                <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dd className="mt-1 text-sm text-gray-400 sm:mt-0 sm:col-span-3">
                    <div className="text-lg font-bold mb-4">Productos recibidos del retorno</div>
                  </dd>
                </div>
                <div className="bg-white pb-5 w-full">
                  <div className="w-full text-left">
                    <div className="bg-gray-50 px-6">
                      <div className="text-gray-500 font-sm uppercase grid grid-cols-12">
                        <div className="py-3">Imagen</div>
                        <div className="py-3 col-span-2">Producto</div>
                        <div className="py-3 col-span-2">UPC</div>
                        <div className="py-3">SKU</div>
                        <div className="py-3">Enviadas</div>
                        <div className="py-3">Recibidas</div>
                        <div className="py-3">Lote</div>
                        <div className="py-3">{t('returns.receive_return.returned_undamaged_pieces')}</div>
                        <div className="py-3">{t('returns.receive_return.returned_damaged_pieces')}</div>
                        <div className="py-3">{t('returns.receive_return.missing_pieces')}</div>
                      </div>
                    </div>
                    <div className="p-3">
                      {uniqueSubmitableProducts.map(submitableProduct => {
                        return (
                          <>
                            <div
                              className="text-gray-500 grid grid-cols-12 border rounded-lg mb-3 my-6"
                              key={submitableProduct.damaged ? String(submitableProduct.product_id) + 'D' : String(submitableProduct.product_id)}
                            >
                              <div className="p-3 py-6">
                                <TableImage
                                  thumbnail_image={submitableProduct.product_image_path?.thumbnail_path}
                                  regular_image={submitableProduct.product_image_path?.path}
                                ></TableImage>
                              </div>
                              <div className="p-3 py-6 col-span-2">
                                {submitableProduct.label}{' '}
                                {submitableProduct.damaged && <i className="text-red-500">{t('returns.receive_return.damaged_pieces')}</i>}
                              </div>
                              <div className="py-6 col-span-2">{submitableProduct.upc ? submitableProduct.upc : t('returns.receive_return.no_upc')}</div>
                              <div className="py-6">
                                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 mx-1">
                                  {submitableProduct.sku}
                                </span>
                                {submitableProduct.requires_unit_code && (
                                  <div className="mt-2">
                                    {submitData.products
                                      .filter(p => p.product_id == submitableProduct.product_id)
                                      .flatMap(p => [...(p.unit_codes || []), ...(p.unit_codes_damaged || []), ...(p.unit_codes_missing || [])])
                                      .map(code => (
                                        <div
                                          key={code}
                                          className="inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium bg-blue-800 text-white mx-1 mb-1"
                                        >
                                          {code}
                                        </div>
                                      ))}
                                  </div>
                                )}
                              </div>
                              <div className="py-6">
                                {returnData?.returned_order?.order_lines
                                  .filter(line => line.product?.id === submitableProduct.product_id)
                                  .reduce((total, line) => total + line.quantity, 0)}
                              </div>
                              <div className="py-6">
                                {submitData.products
                                  .filter(product => product.product_id == submitableProduct.product_id)
                                  .reduce((total, product) => total + product.quantity + product.quantity_damaged, 0)}
                              </div>
                              <div className="col-span-4">
                                {submitData.products
                                  .filter(product => product.product_id == submitableProduct.product_id)
                                  .map((product, index) => {
                                    return (
                                      <div
                                        className={`grid grid-cols-6 mr-3 ${!skipProductLotInReturns && product.has_expiration && submitData.products.filter(product => product.product_id == submitableProduct.product_id).length > 1 ? 'border rounded-lg my-3' : ''}`}
                                      >
                                        <div className="py-6 pl-1 col-span-2">
                                          {product.is_missing ? (
                                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium bg-yellow-100 text-yellow-700 mx-1">
                                              {t('returns.receive_return.missing')}
                                            </span>
                                          ) : !skipProductLotInReturns && product.has_expiration && product.selected_lot ? (
                                            <div className="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium bg-blue-800 text-white mx-1">
                                              {product.selected_lot.unique_code}
                                            </div>
                                          ) : (
                                            t('returns.receive_return.no_lot_required')
                                          )}
                                        </div>
                                        <div className="py-6">{product.quantity}</div>
                                        <div className="py-6">{product.quantity_damaged}</div>
                                        <div className="py-6">{product.quantity_missing || 0}</div>
                                        <div className="py-6 text-right pr-3">
                                          <Button className="px-2 has-tooltip ml-2" dense type="secondary" onClick={() => removeSubmitableProduct(product)}>
                                            <span className="tooltip rounded shadow-lg p-1.5 bg-black text-white -mt-12">
                                              {t('returns.receive_return.remove_product')}
                                            </span>
                                            <TrashIcon className="w-4 h-4" />
                                          </Button>
                                        </div>
                                      </div>
                                    )
                                  })}
                              </div>
                            </div>
                          </>
                        )
                      })}
                    </div>
                  </div>
                </div>
              </dl>
            </div>
            <div className="flex place-content-end pb-3 px-3">
              <Button
                className="mr-2"
                onClick={() => {
                  history.push(RETURNS.replace(':warehouse_id', warehouse_id))
                }}
                type="secondary"
              >
                {t('returns.receive_return.cancel')}
              </Button>
              <Button className="" onClick={() => handleSaveClick()}>
                {t('returns.receive_return.save')}
              </Button>
            </div>
            <ConfirmDialog
              open={showConfirmDialog}
              setOpen={val => setShowConfirmDialog(val)}
              cancelLabel={t('returns.receive_return.cancel')}
              confirmLabel={t('returns.receive_return.confirm')}
              description={`${t('returns.receive_return.confirm_receipt_description', {
                count: totalProductItems,
                plural: totalProductItems > 1 ? 's' : '',
              })}${missingProducts}`}
              isHtmlDescription={true}
              title={t('returns.receive_return.confirm_receipt_title')}
              loading={loadingSubmit}
              onConfirm={() => onSubmitConfirm()}
              afterLeave={() => setAllMissingPending(false)}
            />
            <ConfirmDialog
              open={!!allMissingProducts && !allMissingPending}
              setOpen={val => {
                if (!val) setAllMissingProducts(null)
              }}
              type="danger"
              cancelLabel={t('returns.receive_return.cancel')}
              confirmLabel={t('returns.receive_return.all_missing_confirm')}
              description={allMissingDescription}
              isHtmlDescription={true}
              title={t('returns.receive_return.all_missing_title')}
              loading={loadingSubmit}
              onConfirm={() => onSubmitConfirm({ confirmAllMissing: true })}
            />
          </div>
        )}
        <CreateLotsDialog
          open={showCreateLotsDialog}
          onSuccess={lots => {
            console.log('Created lots', lots)
            setShowCreateLotsDialog(false)
            const products = [...foundProducts]
            const index = products.findIndex(product => product.product_id == productToCreateLot.id)
            products[index].lots = [...products[index].lots, ...lots]
            products[index].selected_lot = lots[0]
            refetch()
            setFoundProducts(products)
          }}
          onCancel={() => setShowCreateLotsDialog(false)}
          lots={[]}
          products={[productToCreateLot]}
          replenishment_products={[]}
          replenishment_id={0}
        ></CreateLotsDialog>
        <ConfirmDialog
          open={showInspectionModal}
          setOpen={() => handleInspectionModalConfirm()}
          hideCancel={true}
          title={t('returns.receive_return.inspection_modal_title')}
          description={t('returns.receive_return.inspection_modal_description')}
          confirmLabel={t('returns.receive_return.inspection_modal_confirm')}
          onConfirm={() => handleInspectionModalConfirm()}
        />
        <DialogView className="w-full" setOpen={setOpenDialogLabel} open={openDialogLabel}>
          <GenerateReplenishmentLabel
            replenishment_info={replenishmentInfo}
            onCancel={() => {
              setOpenDialogLabel(false)
              history.push(RETURNS.replace(':warehouse_id', warehouse_id))
            }}
            onSuccess={() => {
              setOpenDialogLabel(false)
              history.push(RETURNS.replace(':warehouse_id', warehouse_id))
            }}
          />
        </DialogView>
      </PageView>
      <Switch>
        <Route exact path={SHOW_RECEIVING_ORDER}>
          <SlidePanel title={t('returns.receive_return.view_order')} referrer={RECEIVE_RETURN.replace(':id', id).replace(':warehouse_id', warehouse_id)}>
            <ShowOrderContainer />
          </SlidePanel>
        </Route>

        <Route exact path={SHOW_CREATING_RETURN_ORDER}>
          <SlidePanel
            title={t('returns.receive_return.view_order')}
            referrer={CREATE_RETURN.replace(':orderId', orderId).replace(':warehouse_id', warehouse_id)}
          >
            <ShowOrderContainer />
          </SlidePanel>
        </Route>
      </Switch>

      <Notification
        show={notificationMessage.show}
        title={notificationMessage.title}
        type={notificationMessage.type}
        setShow={showNotification => setNotificationMessage({ ...notificationMessage, show: showNotification })}
      />
    </>
  )
}
